import { Component, Vue, Watch } from 'vue-property-decorator';
import { GetterTypes } from '@/store-vuex/types';
import AvailableAppointments from '@/components/AvailableAppointments/AvailableAppointments';
import { AppointmentDTO } from '@/models/AppointmentDTO';

/**
 * Component showing a datepicker with arrows and the available list of appointments
 */
@Component({
    components: {
      AvailableAppointments,
    },
})
export default class AppointmentSelection extends Vue {
  public showPrevButton: boolean = true;
  public showNextButton: boolean = false;

  /**
   * Gets the current AppointmentDTO instance
   *
   * @returns {AppointmentDTO} The current AppointmentDTO instance
   */
  public get appointment(): AppointmentDTO { return this.$store.getters[GetterTypes.appointment]; }

  /**
   * Gets true if the current TRM gender has to used otherwise false
   *
   * @returns {boolean} true or false
   */
  public get useTRMGenderChoice(): boolean {
    return this.$store.getters[GetterTypes.useTRMGenderChoice];
  }

  /**
   * Gets true if long term appointments have to be used otherwise false
   *
   * @returns {boolean} true or false
   */
  public get useLongAppointment(): boolean {
      return this.$store.getters[GetterTypes.useLongAppointment];
  }

  /**
   * Function called when a date is selected
   */
  public onEventSelected(): void {
    this.showNextButton = true;
  }

  /**
   * Initializes the component data
   */
  protected async mounted() {
    if (!this.useTRMGenderChoice && !this.useLongAppointment) {
      this.showPrevButton = false;
    }

    this.showNextButton = this.appointment.appDate != null && this.appointment.center != null;
  }

  /**
   * Function called when the next button is clicked
   */
  protected next() {
    if (this.appointment.slotId !== 0) {
      this.$router.push({
        name: 'recap',
        params: this.$route.params,
      });
    }
  }
}
